import { TextField } from "@mui/material";
import { useState, useReducer } from "react";
import Button1 from "../ResubleComp/Button";
const ReplyPost = ({
  baseUrl,
  token,
  post,
  commentOpen,
  width,
  forceUpdate,
}) => {
  const [replies, setReplies] = useState([]);
  const [newReply, setNewReply] = useState("");
  const postReplies = async () => {
    if (newReply.trim()) {
      setReplies([...replies, newReply]);
      setNewReply("");
    }

    const postRepliesEndpoint = `${baseUrl}/api/post/comment/${post._id}`;
    const requestBody = {
      comment: newReply,
    };

    const response = await fetch(postRepliesEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
      body: JSON.stringify(requestBody),
    });
    forceUpdate();
  };
  const fun = (e) => {
    const { name } = e.target;
    // setNewReply((pre)=>[...pre ,newReply ])
    // setNewReply(()=>{...newReply , [name]:value})
  };

  return (
    <div>
      {commentOpen && (
        <div className="flex items-center justify-center gap-10 mt-5 pl-2 pr-2">
          <TextField
            placeholder="Add Reply"
            name="placecontent"
            InputProps={{
              className: "rounded-full border-2 border-slate-500 text-left",
              style: {
                width: width > 768 ? "440px" : "190px",
                height: width > 768 ? "50px" : "40px",
                appearance: "none",
                border: "none",
                outline: "none",
              },
            }}
            value={newReply}
            onChange={(e) => {
              setNewReply(e.target.value);
            }}
          />
          <Button1
            onClick={postReplies}
            primary
            className="pb-2 pt-2 rounded-md cursor-pointer"
            style={{
              width: width > 768 ? "120px" : "100px",
              height: width > 768 ? "50px" : "40px",
            }}
          >
            Reply
          </Button1>
        </div>
      )}
    </div>
  );
};

export default ReplyPost;
